// extracted by mini-css-extract-plugin
module.exports = {"root":"Legend_root__2jVLu","item":"Legend_item__3sXwj","circle":"Legend_circle__Oq54T","name":"Legend_name__c9tEc","active":"Legend_active__1tFpd"};